/*
* Menu de navegação principal
*/ 

const mobileMenuButton = document.getElementById('mobile-menu-button');
const mobileMenu = document.getElementById('mobile-menu');
if(mobileMenuButton){
  mobileMenuButton.addEventListener('click', () => {
    if (mobileMenu.classList.contains('max-h-0')) {
      mobileMenu.classList.remove('max-h-0');
      mobileMenu.classList.add('max-h-screen');
    } else {
      mobileMenu.classList.add('max-h-0');
      mobileMenu.classList.remove('max-h-screen');
  
    }
  });
}


/*
* Perguntas frequentes: accordion
*/ 
if(document.querySelectorAll('.container-perguntas').length){
  document.querySelectorAll('.header-pergunta').forEach((header) => {
    header.addEventListener('click', function () {
      const body = this.nextElementSibling; // Seleciona o próximo elemento (que é o body-pergunta)
      
      // Verifica se o body já está aberto (max-height maior que 0)
      if (body.style.maxHeight && body.style.maxHeight !== "0px") {
        // Fecha o body
        body.style.maxHeight = "0px";
        const icon = this.querySelector('.arrow-icon');
        icon.classList.remove('rotate-180'); // Gira a seta para posição "fechada"
      } else {
        // Fecha todas as outras perguntas
        document.querySelectorAll('.body-pergunta').forEach((bodyItem) => {
          bodyItem.style.maxHeight = "0px"; // Fecha todos
          const icon = bodyItem.previousElementSibling.querySelector('.arrow-icon');
          icon.classList.remove('rotate-180'); // Gira a seta para posição "fechada"
        });

        // Abre a pergunta atual
        body.style.maxHeight = body.scrollHeight + "px"; // Define a altura do body com base no conteúdo
        const icon = this.querySelector('.arrow-icon');
        icon.classList.add('rotate-180'); // Gira a seta para posição "aberta"
      }
    });
  });
}
